import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useListPeriodicJobs: undefined;
	useTriggerPeriodicJob: undefined;
}

const ADMIN_PERIODIC_JOBS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"admin-periodic-jobs",
	["useListPeriodicJobs", "useTriggerPeriodicJob"],
);

export { ADMIN_PERIODIC_JOBS_SERVICE_KEYS };
